import * as yup from 'yup';
import {
  AUTH_PASSWORD_CONFIRMATION_ERROR,
  AUTH_PASSWORD_MIN_LENGTH,
  getDefaultAuthPasswordRequirementsMessage,
} from 'common/constants/auth';
import { buildRequiredEmailLikeSchema } from 'pages/Auth/utils';
import {
  SIGN_UP_CONFIRM_PASSWORD_REQUIRED_ERROR,
  SIGN_UP_EMAIL_FORMAT_ERROR,
  SIGN_UP_EMAIL_MAX_LENGTH,
  SIGN_UP_EMAIL_MAX_LENGTH_ERROR,
  SIGN_UP_EMAIL_REQUIRED_ERROR,
  SIGN_UP_FIRST_NAME_MAX_LENGTH,
  SIGN_UP_FIRST_NAME_MAX_LENGTH_ERROR,
  SIGN_UP_FIRST_NAME_REQUIRED_ERROR,
  SIGN_UP_LAST_NAME_MAX_LENGTH,
  SIGN_UP_LAST_NAME_MAX_LENGTH_ERROR,
  SIGN_UP_LAST_NAME_REQUIRED_ERROR,
  SIGN_UP_PASSWORD_REQUIRED_ERROR,
} from './SignUp.constants';

const defaultAuthPasswordRequirementsMessage = getDefaultAuthPasswordRequirementsMessage();

export const SIGN_UP_SCHEMA = yup.object({
  email: buildRequiredEmailLikeSchema(SIGN_UP_EMAIL_REQUIRED_ERROR, SIGN_UP_EMAIL_FORMAT_ERROR).max(
    SIGN_UP_EMAIL_MAX_LENGTH,
    SIGN_UP_EMAIL_MAX_LENGTH_ERROR
  ),
  first_name: yup.string().trim().required(SIGN_UP_FIRST_NAME_REQUIRED_ERROR).max(
    SIGN_UP_FIRST_NAME_MAX_LENGTH,
    SIGN_UP_FIRST_NAME_MAX_LENGTH_ERROR
  ),
  last_name: yup.string().trim().required(SIGN_UP_LAST_NAME_REQUIRED_ERROR).max(
    SIGN_UP_LAST_NAME_MAX_LENGTH,
    SIGN_UP_LAST_NAME_MAX_LENGTH_ERROR
  ),
  password: yup
    .string()
    .required(SIGN_UP_PASSWORD_REQUIRED_ERROR)
    .min(AUTH_PASSWORD_MIN_LENGTH, defaultAuthPasswordRequirementsMessage)
    .matches(/[A-Za-z]/, defaultAuthPasswordRequirementsMessage)
    .matches(/\d/, defaultAuthPasswordRequirementsMessage)
    .matches(/\W/, defaultAuthPasswordRequirementsMessage),
  re_password: yup
    .string()
    .required(SIGN_UP_CONFIRM_PASSWORD_REQUIRED_ERROR)
    .oneOf([yup.ref('password')], AUTH_PASSWORD_CONFIRMATION_ERROR),
});
